import React from 'react';
import { Box, keyframes } from '@mui/material';
import { theme } from '../theme';
import Logo2 from '../assets/logo2.svg';

// Animation keyframes for the pulsing light effect
const pulseLight = keyframes`
  0% {
    opacity: 0.3;
    transform: scale(0.95);
    filter: brightness(0.7);
  }
  50% {
    opacity: 1;
    transform: scale(1);
    filter: brightness(1.2);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.95);
    filter: brightness(0.7);
  }
`;

// Animation for the background light gradient with smooth transitions
const backgroundPulse = keyframes`
  0% {
    background: radial-gradient(circle at center, rgba(239, 240, 222, 0.1) 0%, rgba(239, 240, 222, 0.05) 40%, transparent 70%);
  }
  25% {
    background: radial-gradient(circle at 30% 30%, rgba(239, 240, 222, 0.2) 0%, rgba(239, 240, 222, 0.1) 40%, transparent 70%);
  }
  50% {
    background: radial-gradient(circle at center, rgba(239, 240, 222, 0.15) 0%, rgba(239, 240, 222, 0.08) 40%, transparent 70%);
  }
  75% {
    background: radial-gradient(circle at 70% 70%, rgba(239, 240, 222, 0.2) 0%, rgba(239, 240, 222, 0.1) 40%, transparent 70%);
  }
  100% {
    background: radial-gradient(circle at center, rgba(239, 240, 222, 0.1) 0%, rgba(239, 240, 222, 0.05) 40%, transparent 70%);
  }
`;

const LandingPage = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundColor: theme.palette.bunoColors.spaceBlue,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Animated background layer */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          animation: `${backgroundPulse} 8s ease-in-out infinite`,
          transition: 'background 1.5s ease-in-out',
          zIndex: 1,
        }}
      />
      
      {/* Additional floating light elements */}
      <Box
        sx={{
          position: 'absolute',
          top: '20%',
          left: '15%',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: `radial-gradient(circle, ${theme.palette.bunoColors.eggshell}20 0%, transparent 70%)`,
          animation: `${pulseLight} 6s ease-in-out infinite 1s`,
          transition: 'opacity 2s ease-in-out, transform 2s ease-in-out',
          zIndex: 1,
        }}
      />
      
      <Box
        sx={{
          position: 'absolute',
          bottom: '25%',
          right: '20%',
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          background: `radial-gradient(circle, ${theme.palette.bunoColors.eggshell}15 0%, transparent 70%)`,
          animation: `${pulseLight} 7s ease-in-out infinite 3s`,
          transition: 'opacity 2s ease-in-out, transform 2s ease-in-out',
          zIndex: 1,
        }}
      />
      
      {/* Main logo container */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          component="img"
          src={Logo2}
          alt="Buno Pro Logo"
          sx={{
            width: {
              xs: '280px',
              sm: '350px',
              md: '450px',
              lg: '559px',
            },
            height: 'auto',
            filter: `brightness(0) saturate(100%) invert(92%) sepia(11%) saturate(345%) hue-rotate(25deg) brightness(96%) contrast(94%)`,
            // This filter converts the logo to eggshell color (#EFF0DE)
            transition: 'all 0.3s ease',
          }}
        />
      </Box>
      
      {/* Subtle gradient overlay for depth */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `linear-gradient(45deg, ${theme.palette.bunoColors.spaceBlue}90 0%, transparent 50%, ${theme.palette.bunoColors.spaceBlue}90 100%)`,
          zIndex: 0,
          opacity: 0.3,
        }}
      />
    </Box>
  );
};

export default LandingPage; 